import AxiosServices from "./AxiosService";

const Auth = new AxiosServices();


class FeedBackService {

    CreateFeedBack = async (feedback) => {
        return Auth.post('/feedback/submit', feedback)
    };

    UpdateFeedBack = async (feedbackId, feedback) => {
        return Auth.put(`/feedback/${feedbackId}`, feedback)
    };

    GetFeedBackById = async (feedbackId) => {
        return Auth.get(`/feedback/${feedbackId}`)
    };
    
    GetAllPublicFeedBacks = async (limit = 10) => {
        return Auth.get(`feedback/top-courses?limit=${limit}`)
    };

    GetAllAdminFeedBacks = async (page = 1, limit = 10) => {
        return Auth.get(`feedback/admin/all?page=${page}&limit=${limit}`)
    };


    GetFeedBackByCourseId = async (courseId) => {
        return Auth.get(`/feedback/course/${courseId}`)
    };
    
    GetUserSubmittedFeedBacks = async (page = 1, limit = 10) => {
        return Auth.get(`/feedback/my-feedbacks?page=${page}&limit=${limit}`)
    };

    DeleteFeedBackById = async (feedbackId) => {
        return Auth.delete(`/feedback/${feedbackId}`)
    };
    
}

export default FeedBackService

